import { defineStore } from 'pinia'

import { useMenuStore } from '@/stores/menuStore'
import { IAppSettings } from '@/types/settings.type'
import { request } from '@/utils/request'

const GET_SETTINGS_URL = '/api/settings'

interface SettingsState {
  isLoading: boolean
  settings: IAppSettings | null
}

export const useSettingsStore = defineStore('SettingsStore', {
  state: (): SettingsState => ({
    isLoading: false,
    settings: null
  }),

  getters: {
    /**
     * Возвращает текущие настройки
     */
    getSettings: (state) => state.settings,

    /**
     * Пользователь авторизован
     */
    isAuthorized: (state) => !!state.settings?.authorized,

    /**
     * Название организации для компактных элементов интерфейса
     */
    organizationName: (state) => state.settings?.orgNameShort?.trim() || state.settings?.orgName || '',

    /**
     * Настройки пустые
     */
    isEmpty: (state) => !state.settings || Object.keys(state.settings).length === 0
  },

  actions: {

    /**
     * Получает настройки из API и обновляет хранилище
     */
    async loadSettings () {
      try {
        this.isLoading = true
        const { data } = await request(GET_SETTINGS_URL)

        if (data.settings) {
          this.setSettings(data.settings)
        }

        return this.settings
      } catch (error) {
        console.error('Ошибка загрузки настроек', error)
        return null
      } finally {
        this.isLoading = false
      }
    },

    /**
     * Устанавливает новые настройки в store
     */
    setSettings (settings: IAppSettings) {
      this.settings = settings

      // Сразу обновляем меню
      const menuStore = useMenuStore()
      menuStore.setItems(menuStore.prepareItems(settings.SideNav || []))
    },

    /**
     * Обновляет отдельное поле в настройках
     */
    updateSetting (key: string, value: any) {
      if (!this.settings) this.settings = {} as IAppSettings
      this.settings = { ...this.settings, [key]: value }
    },

    /**
     * Сбрасывает все настройки
     */
    resetSettings () {
      this.settings = null
    }
  }
})
